import $ from 'jquery'
import store_param from "@/store/mods/parametres/config"
import draggable from 'vuedraggable';
import { ageFields, ageRange } from './age-eligibility'

export default {
    name: 'manage-antecedent',
    components: {
        draggable
    },
    props: {
        toggler: Number,
        selected_atcd: Object,
        section_antecedents: Array
    },
    data() {
        return {
            select_all: '',
            checked_consult: [],
            all_checked: false,
            one_is_checked: [],
            text_grey: [],
            atcd_data: {
                libelle: "",
                type_consultations: [],
                target_gender: 'ALL'
            },
            age_fields: ageFields(),
            age_error: '',
            save_loading: false,
            empty_msg_error: "",
            err_message: "",
            is_confirm: false,
        }
    },

    watch: {
        toggler() {
            this.clearError()
            this.atcd_data = {
                libelle: "",
                type_consultations: [],
                target_gender: 'ALL'
            }
            this.age_fields = ageFields()
            this.age_error = ''
            this.one_is_checked = []
            this.all_checked = false
            
            this.fillFields()
            
        }
    },

    computed: {
        list_consultations() {
            return this.$store.getters["list_consultations"];
        },
    },

    mounted() {
        this.$store.dispatch("getTousTypeConsultations")
    },

    methods: {
        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        fillFields() {
            this.atcd_data.libelle = this.selected_atcd.atcd_label
            this.atcd_data.target_gender = this.selected_atcd.target_gender || 'ALL'
            this.age_fields = ageFields(this.selected_atcd)
            this.one_is_checked = []
            this.text_grey = []

            if (this.selected_atcd.type_consultations.length > 0) {
                this.selected_atcd.type_consultations.forEach(el => {
                    this.list_consultations.forEach(lc => {
                        if (el.type_consultation_id == lc.id) {
                            this.one_is_checked.push(lc.id)
                            this.text_grey[lc.id] = 'text-grey'
                        }
                    });
                });
            }
            
        },

        toutSelectionner() {
            let is_checked = $('#all-c').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                let i = 0
                this.list_consultations.forEach((data) => {
                    this.text_grey[i] = 'text-grey'
                    this.one_is_checked.push(data.id)
                    i++
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false

                let i = 0
                this.list_consultations.forEach(() => {
                    this.text_grey[i] = ''
                    i++
                });
            }
        },

        onOneChange(index) {
            this.empty_msg_error = ""
            let is_checked = $('#tc'+index).is(":checked")

            let c = ''
            if (is_checked == true) {
                c = 'text-grey'
            }
            this.text_grey[index] = c

            document.getElementById("all-c").checked = false;
        },

        async saveAntecedent() {
            if (this.save_loading) return
            const isValid = await this.$refs.atcd_form.validate();
            if (!isValid) {
                return;
            }

            if (this.one_is_checked.length == 0) {
                this.empty_msg_error = "Veuillez sélectionner au moins un type de consultation !"
                return;
            }

            let range
            try {
                range = ageRange(this.age_fields)
                this.age_error = ''
            } catch (error) {
                this.age_error = error.message
                return
            }

            const data = {
                atcd_id: (this.selected_atcd.atcd_id)?this.selected_atcd.atcd_id:0,
                libelle: this.atcd_data.libelle,
                type_consultations: this.one_is_checked,
                target_gender: this.atcd_data.target_gender,
                min_age_months: range.min_age_months,
                max_age_months: range.max_age_months
            }
            this.save_loading = true
            try {
                const response = await store_param.saveSectionAntecedents(data)
                if (response.success) {
                    this.one_is_checked = []
                    this.$refs.ges_atcd.click()
                    this.successToast(response.message)

                    this.$emit('emitSectionAntecedent')
                } else {
                    this.err_message = response.message
                }
            } catch (error) {
                this.err_message = "Une erreur est survenue ! Merci de réessayer plus tard."
            } finally {
                this.save_loading = false
            }
        },

        clearError() {
            this.is_error = false
            this.err_message = ""
            this.empty_msg_error = ""
            this.age_error = ''

            this.is_confirm = false
        },

        saveReorder() {
            const champs = this.section_antecedents.map(item => item.atcd_id);
            let data = {
                champs: champs
            }

            this.save_loading = true
            store_param.reorderSectionAntecedents(data).then((response) => {
                if (response.success) {
                    this.successToast(response.message)
                    this.$emit('emitSectionAntecedent')
                    this.$refs.reorder_atcd.click()
                } else {
                    this.err_message = response.message
                }

                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.err_message = "Une erreur est survenue ! Merci de réessayer plus tard."
            })
        },

        deactivateATCD(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            const data = {
                atcd_id: this.selected_atcd.atcd_id
            }

            this.save_loading = true
            store_param.deactivateATCDPatient(data).then((response) => {
                if (response.success) {
                    this.successToast(response.message)
                    this.$emit('emitSectionAntecedent')
                    this.$refs.deactivate_atcd.click()

                    this.is_confirm = false
                } else {
                    this.err_message = response.message
                }

                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.err_message = "Une erreur est survenue ! Merci de réessayer plus tard."
            })
        },
    }
}
